import RectLinear from '../rectLinear/';
import {mixedMeasure} from '../default/';
import {setMethodsFromAttrs} from '../../modules/util';
import _axis from './_axis';
import _munge from './_munge';
import _scale from './_scale';
import _region from './_region';
import _legend from './_legend';
import _facet from './_facet';
import _tooltip from './_tooltip';

const curves = ['linear', 'stepped', 'curved'];
const size = {range: [2, 2], scale: 'linear', reverse: false};
const conditions = ['normal'];
const _attrs = {
  curve: curves[0],
  facet: false,
  padding: 0.05,
  point: false,
  pointRatio : 3,
  regionPadding: 0.1,
  size: size,
};

class Combo extends RectLinear {
  constructor() {
    super(_attrs);
  }
}

function _combo() {
  let line =  new Combo();
  return line;
}

function update() {
 // 데이터가 바뀐 경우

 // 데이터의 계산에 영향 주는 요소가 바뀐 경우

 // 다른 화면 요소가 바뀐 경우 
}

function measureName() {
  let measures = this.measures();
  let yField;
  if (this.condition() === conditions[2]) yField = mixedMeasure.field; 
  else if (this.aggregated() && measures[0].field === mixedMeasure.field) yField = measures[0].field;
  else yField = measures[0].field + '-' + measures[0].op;
  return yField;
}

function isCount() {
  return this.condition() === conditions[1];
}

function renderLayout(keep) { //완벽히 처음부터 업데이트
  this.reset(keep);
  this.renderFrame();
  _munge.call(this);
  _scale.call(this, keep);
  this.renderCanvas();
  _region.call(this);
  _facet.call(this);
  _axis.call(this);
  _legend.call(this);
  _tooltip.call(this);
}

Combo.prototype.measureName = measureName; //OVERRIDE: measure로 사용되는 필드 이름 자동 생성 
Combo.prototype.renderLayout = renderLayout;
Combo.prototype.update = update;
Combo.prototype.isCount = isCount;
setMethodsFromAttrs(Combo, _attrs);

export default _combo;
export {conditions, curves};



// WEBPACK FOOTER //
// ./layouts/combo/index.js